import { createFileRoute } from "@tanstack/react-router";
import { VendorPromotionPage } from "@/components/vendor/promotion/VendorPromotionPage";

export const Route = createFileRoute("/vendor/promotion")({
  head: () => ({ meta: [{ title: "Promotion · Venue Portal" }] }),
  component: VendorPromotionPage,
});
